type Props = {
  title?: string
  subtitle?: string
  renderedHtml?: string
  fallbackDescription?: string
}

export default function BusinessStory({ title, subtitle, renderedHtml, fallbackDescription }: Props) {
  const hasStoryHtml = Boolean((renderedHtml || '').trim())
  const hasFallback = Boolean((fallbackDescription || '').trim())

  return (
    <article className="mx-auto max-w-3xl">
      {title ? <h2 className="text-3xl font-extrabold tracking-tight text-white md:text-4xl">{title}</h2> : null}
      {subtitle ? <p className="mt-2 text-base italic leading-relaxed text-white/80 md:text-lg">{subtitle}</p> : null}

      {hasStoryHtml ? (
        <div
          className="tiptap-mag prose prose-invert prose-lg mt-6 max-w-none leading-8 prose-headings:font-extrabold prose-headings:tracking-tight prose-h2:mt-10 prose-h2:mb-3 prose-h3:mt-8 prose-h3:mb-2 prose-p:my-4 prose-li:my-1 prose-blockquote:border-l-brand/70 prose-blockquote:text-white/85"
          dangerouslySetInnerHTML={{ __html: renderedHtml || '' }}
        />
      ) : hasFallback ? (
        <div className="mt-6 rounded-2xl border border-white/10 bg-white/5 p-5 text-[17px] leading-8 text-white/85 whitespace-pre-wrap">
          {fallbackDescription}
        </div>
      ) : (
        <div className="mt-6 rounded-2xl border border-white/10 bg-white/5 p-5 text-sm text-white/65">No story yet.</div>
      )}
    </article>
  )
}

